<template>
  <div v-if="isshow" :class="{ fullscreen: fullscreen, mappingOchart: true }">
    <div class="componentclose" @click="isshow = false">X</div>
    <div style="width:100%">
      <div v-if="!fullscreen" class="radish-btn radish-btn-primary radish-btn-small" @click="fullscreen = true">
        全屏展示
      </div>
      <div v-else class="radish-btn radish-btn-primary radish-btn-small" @click="fullscreen = false">半屏展示</div>
      <el-slider v-model="slider"></el-slider>
    </div>
    <OrgChart
      v-if="ochartType === '公司'"
      :data="chartData"
      :vue="Vue"
      :html-to-canvas="html2canvas"
      node-id="_id"
      container-class="orgchart-container"
      chart-class="orgchart-chart"
      common-class="fa"
      spinner-class="fa fa-circle-o-notch fa-spin spinner"
      export-btn-class=""
      left-arrow-class="fa-chevron-left"
      right-arrow-class="fa-chevron-right"
      up-arrow-class="fa-chevron-up"
      down-arrow-class="fa-chevron-down"
      toggle-btn-on-class="fa-plus-square"
      toggle-btn-off-class="fa-minus-square"
      parent-node-symbol-class=""
      :zoom="false"
      :export-button="false"
      :style="`transform:scale(${slider / 100}) translate(${translate},${translate});width:${scale};height:${scale};`"
      @drag="updateDataOnDrag"
    >
      <div slot-scope="{ nodeData }">
        <div
          v-if="nodeData.类型 === 'members'"
          id="memberbox"
          :class="[nodeData.members && nodeData.members.length > 30 ? 'widebox' : 'narrowbox', 'title']"
        >
          <span
            v-for="item in nodeData.members"
            :key="item._id"
            style="position:relative;"
            :class="[item.isLeader ? 'leaderradish' : '', 'alpha-tag mr5 md5']"
          >
            {{ item.姓名 }} <span v-if="item.专业职级">（{{ item.专业职级 }}）</span>
            <span v-if="!item.手机" style="line-height: 14px;" class="cc-icon">c</span>
          </span>
        </div>
        <div v-else-if="nodeData.类型 === 'branch'" id="branchbox">
          <span class="branch-label">分支机构：</span>
          <div class="branch-position-box">
            <div v-for="(item, index) in nodeData.members" :key="item._id" class="branch-node">
              <span class="branch-node-content">{{ item.公司名称 }}</span>
              <div v-if="index !== nodeData.members.length - 1" class="div-ochart-line"></div>
            </div>
          </div>
        </div>
        <div v-else-if="nodeData.isManager" id="org-manager" class="title ">
          <span class="alpha-tag mr5 md5 ">
            {{ nodeData.名称 }} <span v-if="nodeData.专业职级">（{{ nodeData.专业职级 }}）</span>
            <span v-if="!nodeData.手机" style="line-height: 14px;" class="cc-icon">c</span>
          </span>
        </div>
        <div
          v-else
          id="orgdepartment"
          :class="[nodeData.isManager ? 'manager' : '', 'title company-orgdepartment-across']"
          style="overflow:unset"
        >
          <el-badge :is-dot="!!nodeData.isManager" class="item span-maxcontent mt3">{{ nodeData.名称 }}</el-badge>
          <p v-if="nodeData.isManager" class="span-maxcontent ochart-character">{{ nodeData.专业职级 }}</p>
          <p v-else-if="nodeData.A角" class="span-maxcontent ochart-character">{{ nodeData.A角 }}</p>
          <p class="span-maxcontent">
            <span>{{ nodeData.人数 }}</span>
          </p>
        </div>
      </div>
    </OrgChart>

    <OrgChart
      v-else-if="ochartType === '部门'"
      :data="chartData"
      :vue="Vue"
      :html-to-canvas="html2canvas"
      node-id="_id"
      container-class="orgchart-container"
      chart-class="orgchart-chart"
      common-class="fa"
      spinner-class="fa fa-circle-o-notch fa-spin spinner"
      export-btn-class=""
      left-arrow-class="fa-chevron-left"
      right-arrow-class="fa-chevron-right"
      up-arrow-class="fa-chevron-up"
      down-arrow-class="fa-chevron-down"
      toggle-btn-on-class="fa-plus-square"
      toggle-btn-off-class="fa-minus-square"
      parent-node-symbol-class=""
      :zoom="false"
      :export-button="false"
      :style="`transform:scale(${slider / 100}) translate(${translate},${translate});width:${scale};height:${scale};`"
      @drag="updateDataOnDrag"
    >
      <div slot-scope="{ nodeData }">
        <div
          v-if="nodeData.类型 === '部门'"
          id="orgdepartment"
          class="title orgdepartment-across"
          style="overflow:unset"
        >
          <span>
            {{ nodeData.名称 }} <span v-if="nodeData.高管">（{{ nodeData.高管 }}）</span>
            <span v-else-if="nodeData.A角">（{{ nodeData.A角 }}）</span>
          </span>
          <div class="depnumber">{{ getRadishNumberOfDepartment(nodeData) }}</div>
        </div>
        <div v-else-if="nodeData.类型 === '输入'" id="ochart-input-box" class="title narrow-box">
          <el-input v-model="nodeData.名称" size="mini" :disabled="true"></el-input>
        </div>
        <div
          v-else
          id="memberbox"
          :class="[nodeData.members && nodeData.members.length > 30 ? 'widebox' : 'narrowbox', 'title']"
        >
          <span
            v-for="item in nodeData.members"
            :key="item._id"
            style="position:relative;"
            :class="[item.isLeader ? 'leaderradish' : '', 'alpha-tag mr5 md5']"
          >
            {{ item.姓名 }} <span v-if="item.专业职级">（{{ item.专业职级 }}）</span>
            <div v-if="item.A角" class="redradius"></div>
            <span v-if="!item.手机" style="line-height: 14px;" class="cc-icon">c</span>
          </span>
          <span
            v-for="item in nodeData.temporaryRadish"
            :key="item._id"
            style="position:relative;color: #a9a9a9;"
            :class="[item.isLeader ? 'leaderradish' : '', 'alpha-tag info mr5 md5']"
          >
            {{ item.姓名 }} <i class="el-icon-star-on"></i> <i class="el-icon-circle-close" style="margin-left:5px"></i>
          </span>
        </div>
      </div>
    </OrgChart>
  </div>
</template>
<script>
import OrgChart from '@c42/vue-orgchart'
import Vue from 'vue'
import html2canvas from 'html2canvas'

export default {
  components: { OrgChart },
  data() {
    return {
      OrgChart,
      Vue,
      html2canvas,
      isshow: false,
      chartData: {
        _id: 1,
        label: '公司1',
        children: [],
      },
      copychartData: '',
      slider: 100,
      fullscreen: false,
      ochartType: '公司',
    }
  },
  computed: {
    scale: function() {
      return `${10000 / this.slider.toFixed(3)}%`
    },
    translate: function() {
      let num = this.scale.replace('%', '')
      num = `${((num - 100) / 2).toFixed(3)}%`
      return `-${num}`
    },
  },
  methods: {
    async open(id) {
      const res = await app.service('company').getOchartKpi(id)
      if (res.status === 'success') {
        this.ochartType = res.data.type
        this.chartData = res.data.data
        this.copychartData = JSON.parse(JSON.stringify(this.chartData))
        this.isshow = true
        this.fullscreen = false
      } else this.$message.error(res.msg)
    },
    updateDataOnDrag() {
      this.chartData = JSON.parse(JSON.stringify(this.copychartData))
    },
    getRadishNumberOfDepartment(department) {
      if (!department.members) department.members = []
      if (!department.temporaryRadish) department.temporaryRadish = []
      return department.members.length + department.temporaryRadish.length
    },
    toFullscreen() {
      this.fullscreen = true
    },
  },
}
</script>
<style scoped>
.mappingOchart {
  position: fixed;
  top: 60px;
  left: 20px;
  z-index: 1002;
  width: 40vw;
  height: 100vh;
  padding: 10px 15px;
  background-color: #fff;
  border: 1px solid #eaeefb;
  border-radius: 0 !important;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  transition: all 0.2s ease-in-out;
}
.componentclose {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 28px;
  height: 28px;
  color: #fff;
  background-color: #f56c6c;
  border-radius: 50%;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.fullscreen {
  width: calc(100vw - 20px);
}

.orgchart .node {
  width: auto;
  margin: 0;
  background-color: transparent;
  border-radius: 5px;
}
</style>
<style src="../statistics/css/companyOchart.css" scoped></style>
<style src="../statistics/css/departmentOchart.css" scoped></style>
